import React, { useEffect, useRef, useState } from 'react';
import * as S from './styles';

import IconPlusBlue from '../../../assets/icons/icon-plus-blue.svg';
import IconArrowLeft from '../../../assets/icons/icon-arrow-left-nova-home.svg';
import IconArrowRight from '../../../assets/icons/icon-arrow-right-nova-home.svg';

import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { BodyG, TaglineM } from '../../../styles/stylesTypography';
import RegisterAgronomist from '../../AddModals/RegisterAgronomist';
import RegisterProducer from '../../AddModals/RegisterProducer';
import RegisterFarm from '../../AddModals/RegisterFarm';
import { theme } from '../../../styles/theme';
import Modal from "../../../components/modal/modalGenericV2";
import ModalBlock from "../../../components/modal/modalFuncaoBloqueadaImpressaoFe";
import api from '../../../services/api';
import identifyErrorMenssage from '../../../services/identifyErrorMenssage';
import { store } from "react-notifications-component";
import ModalCreateOrEditEvent from '../../modalCreateOrEditEvent';
import { isTotvs, isOmie } from '../../../services/globalFunctions';

export const compendioG = "@compendioG";

const CalendaryEvent = ({ ...props }) => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [showNewEvent, setShowNewEvent] = useState(false);
  const [openModalTrue, setOpenModalTrue] = useState(false);

  const getUserFromStorage = () => {
    try {
      return JSON.parse(localStorage.getItem("@userinfo") || "null");
    } catch (_) {
      return null;
    }
  };

  const isCreateEventBlocked = () => {
    const user = getUserFromStorage();
    const planId = user?.contrato?.agro_plan_config?.agro_plan_id;
    const diasRestante = Number(user?.contrato?.dias_restante ?? 0);
    // 5 = plano com Caderno de Campo nativo; 9/10/11 = Protheus/SIAC/Omie
    // (integrações TOTVS/Omie) - também liberados pra criar evento.
    const planosComCadernoCampo = [5, 9, 10, 11];

    return !planosComCadernoCampo.includes(planId) || (planId === 1 && diasRestante > 0);
  };

  const handleCreateEventClick = (e) => {
    if (isCreateEventBlocked()) {
      setOpenModalTrue(true);
      return;
    }

    setShowNewEvent(true);
  };

  const [events, setEvents] = useState([]);
  const [isEdit, setIsEdit] = useState(false);

  const [titleDrawer, setTitleDrawer] = useState("");
  const [descriptionDrawer, setDescriptionDrawer] = useState("");
  const [agronomistDrawer, setAgronomistDrawer] = useState({
    value: null,
    label: "",
  });
  const [producerDrawer, setProducerDrawer] = useState({
    value: null,
    label: "",
  });
  const [cultureDrawer, setCultureDrawer] = useState({
    value: null,
    label: "",
  });
  const [startDateDrawer, setStartDateDrawer] = useState("");
  const [endDateDrawer, setEndDateDrawer] = useState("");
  const [statusDrawer, setStatusDrawer] = useState({ value: null, label: "" });

  const [agronomists, setAgronomists] = useState([]);
  const [producers, setProducers] = useState([]);
  const [agroFarmsDrawer, setAgroFarmsDrawer] = useState({
    value: null,
    label: "",
  });
  const [agroFarms, setAgroFarms] = useState([]);
  const [cultures, setCultures] = useState([]);

  const [isFarmDisabled, setIsFarmDisabled] = useState(true);
  const [isButtonFarmDisabled, setIsButtonFarmDisabled] = useState(true);

  // Estados para controle de erros
  const [titleError, setTitleError] = useState(false);
  const [descriptionError, setDescriptionError] = useState(false);
  const [agronomistError, setAgronomistError] = useState(false);
  const [producerError, setProducerError] = useState(false);
  const [farmError, setFarmError] = useState(false);
  const [cultureError, setCultureError] = useState(false);
  const [startDateError, setStartDateError] = useState(false);
  const [endDateError, setEndDateError] = useState(false);
  const [statusError, setStatusError] = useState(false);

  // Refs - Drawer
  const selectAgronomistRef = useRef(null);
  const selectProducerRef = useRef(null);
  const selectAgroFarmsRef = useRef(null);
  const selectCultureRef = useRef(null);
  const selectStatusRef = useRef(null);

  //Modal
  const [showAddAgronomist, setShowAddAgronomist] = useState(false);
  const [showAddProducer, setShowAddProducer] = useState(false);
  const [showAddFarm, setShowAddFarm] = useState(false);

  const [idProducer, setIdProducer] = useState(0);

  const [isLoading, setIsLoading] = useState(false);

  const tileClassName = ({ date, view }) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const normalizedDate = new Date(date);
    normalizedDate.setHours(0, 0, 0, 0);

    const selectedDate = new Date(currentDate);
    selectedDate.setHours(0, 0, 0, 0);

    if (view === "month") {

      if (normalizedDate < today) {
        return "react-calendar__tile past-day";
      }

      if (normalizedDate.getTime() === today.getTime()) {
        if (normalizedDate.getTime() === selectedDate.getTime()) {
          return "react-calendar-dateNow-focus";
        }
        return "react-calendar__active--today";
      }

      if (normalizedDate.getTime() === selectedDate.getTime()) {
        return "react-calendar__tile-select";
      }
    }

    return null;
  };

  const getAgroFarms = async (producerId) => {
    if (!producerId) return;

    try {
      const response = await api.get(`/produtores/${producerId}/fazendas`);

      const agroFarmsData = response.data.data.map((agroFarm) => ({
        value: agroFarm.id,
        label: agroFarm.nome,
      }));

      setAgroFarms(agroFarmsData);
      setIsFarmDisabled(false);
      setIsButtonFarmDisabled(false);

      if (agroFarmsData.length === 1) {
        const selectedFarm = {
          value: agroFarmsData[0].value,
          label: agroFarmsData[0].label,
        };

        setAgroFarmsDrawer(selectedFarm);
        setFarmError(false);

        setTimeout(() => {
          if (selectAgroFarmsRef.current) {
            const selectElement = selectAgroFarmsRef.current;

            if (typeof selectElement.handleChange === "function") {
              selectElement.handleChange({
                target: { value: String(selectedFarm.value) },
              });
            }
          }
        }, 100);
      }
    } catch (error) {
      setIsFarmDisabled(true);
      setIsButtonFarmDisabled(false);

      setFarmError(true);

      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(error, "ERRO-583 Nenhuma fazenda foi encontrada para esse produtor - Tente novamente, se o erro persistir acione o suporte."),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
    }
  };

  const clearFields = () => {
    handleLimparSelect();

    setTitleDrawer("");
    setDescriptionDrawer("");
    setAgronomistDrawer({ value: 0, label: "" });
    setProducerDrawer({ value: 0, label: "" });
    setCultureDrawer({ value: 0, label: "" });
    setStartDateDrawer("");
    setEndDateDrawer("");
    setStatusDrawer({ value: 0, label: "" });
    setAgroFarmsDrawer({ value: 0, label: "" });
    setAgroFarms([]);
    setIsFarmDisabled(true);
    setIsButtonFarmDisabled(true);

    // Resetar erros
    setTitleError(false);
    setDescriptionError(false);
    setAgronomistError(false);
    setProducerError(false);
    setFarmError(false);
    setCultureError(false);
    setStartDateError(false);
    setEndDateError(false);
    setStatusError(false);
  };

  const handleLimparSelect = () => {
    if (selectAgronomistRef.current) {
      selectAgronomistRef.current.clearSelect();
    }

    if (selectProducerRef.current) {
      selectProducerRef.current.clearSelect();
    }

    if (selectAgroFarmsRef.current) {
      selectAgroFarmsRef.current.clearSelect();
    }

    if (selectCultureRef.current) {
      selectCultureRef.current.clearSelect();
    }

    if (selectStatusRef.current) {
      selectStatusRef.current.clearSelect();
    }
  };
  const handleEditEvent = async (item) => { };

  const handleSaveEvent = async () => {
    if (!validateForm()) {
      store.addNotification({
        title: "Erro!",
        message: "Preencha todos os campos obrigatórios",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
      return;
    }

    setIsLoading(true);

    const payload = {
      title: titleDrawer,
      agro_agronomist_id: parseInt(agronomistDrawer.value),
      agro_producer_id: parseInt(producerDrawer.value),
      agro_farm_id: parseInt(agroFarmsDrawer.value),
      description: descriptionDrawer,
      agro_culture_id: parseInt(cultureDrawer.value),
      date_begin: formatarDataParaAPI(startDateDrawer),
      date_end: formatarDataParaAPI(endDateDrawer),
      agro_task_status_id: parseInt(statusDrawer.value),
    };

    try {
      const response = await api.post("/agenda", payload);

      if (response) {
        setShowNewEvent(false);
        setIsEdit(false);
        clearFields();

        getEvents();

        store.addNotification({
          title: "Sucesso!",
          message: `${response.data.message}`,
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: { duration: 4000, onScreen: true },
        });
      }
    } catch (error) {
      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(error, "ERRO-584 Erro ao salvar evento - Tente novamente, se o erro persistir acione o suporte."),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
    } finally {
      setIsLoading(false);
    }
  };

  const validateForm = () => {
    let isValid = true;

    // Resetar todos os erros
    setTitleError(false);
    setDescriptionError(false);
    setAgronomistError(false);
    setProducerError(false);
    setFarmError(false);
    setCultureError(false);
    setStartDateError(false);
    setEndDateError(false);
    setStatusError(false);

    // Validar cada campo
    if (!titleDrawer.trim()) {
      setTitleError(true);
      isValid = false;
    }

    if (!agronomistDrawer.value) {
      setAgronomistError(true);
      isValid = false;
    }

    if (!startDateDrawer) {
      setStartDateError(true);
      isValid = false;
    }

    if (!endDateDrawer) {
      setEndDateError(true);
      isValid = false;
    }

    if (!statusDrawer.value) {
      setStatusError(true);
      isValid = false;
    }

    return isValid;
  };

  const formatarDataParaAPI = (dataLocal) => {
    if (!dataLocal) return "";
    const date = new Date(dataLocal);

    const offset = date.getTimezoneOffset() * 60000;
    return new Date(date.getTime() - offset).toISOString();
  };

  const getEvents = async () => {
    try {
      const response = await api.get("/agenda/resumo");

      if (response) {
        setEvents(response.data);
      }
    } catch (error) { }
  };

  const formatCPFOrCNPJ = (value) => {
    const cleaned = value.replace(/\D/g, "");
    return cleaned.length <= 11 ? formatCPF(value) : formatCNPJ(value);
  };

  const formatCPF = (value) => {
    if (!value) return "";

    value = value.replace(/\D/g, "");

    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");

    return value;
  };

  const formatCNPJ = (value) => {
    if (!value) return "";
    value = value.replace(/\D/g, "").slice(0, 14);
    value = value.replace(/^(\d{2})(\d)/, "$1.$2");
    value = value.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
    value = value.replace(/\.(\d{3})(\d)/, ".$1/$2");
    value = value.replace(/(\d{4})(\d)/, "$1-$2");
    return value;
  };

  const getAgronomists = async () => {
    const payload = {
      search: "",
      estado: "",
    };

    try {
      const response = await api.post(
        "/agronomos/pesquisa?limit=30&offset=0",
        payload
      );

      const agronomistsData = response.data.data.agronomists.map(
        (agronomist) => ({
          value: agronomist.id,
          label: agronomist.nome,
        })
      );

      setAgronomists(agronomistsData);

      if (agronomistsData.length === 1) {
        setAgronomistDrawer({
          value: agronomistsData[0].value,
          label: agronomistsData[0].label,
        });
        setAgronomistError(false);
      }
    } catch (error) {
    }
  };

  const getAllProducers = async () => {
    const payload = {
      search: "",
      estado: "",
      order_by: { field: "modified", order: "DESC" }
    };

    try {
      const response = await api.post("/produtores/pesquisa?limit=30&offset=0", payload);

      const produtores = response.data.data.produtores;

      const producersData = produtores.map((producer) => ({
        value: producer.id,
        label:
          (producer.id_externo && !isOmie() ? producer.id_externo + ": " : "") +
          producer.nome +
          " - " +
          formatCPFOrCNPJ(producer.cpf_cnpj),
        agro_farms: producer.agro_farms.map((farm) => ({
          id: farm.id,
          label: farm.nome,
          state: farm.estado,
        })),
      }));

      setProducers(producersData);

      if (producersData.length === 1) {
        const unico = producersData[0];
        setProducerDrawer({ value: unico.value, label: unico.label });
        setProducerError(false);
        // getAgroFarms(unico.value);
      }

    } catch (error) {
      console.error("Erro ao buscar produtores:", error);
    }
  };

  const getCultures = async () => {
    try {
      const response = await api.get("/culturas");

      const allCultures = response.data.data.flat();

      const culturesData = allCultures.map((culture) => ({
        value: culture.id,
        label: culture.nome_comum,
      }));

      setCultures(culturesData);

      if (culturesData.length === 1) {
        setCultureDrawer({
          value: culturesData[0].value,
          label: culturesData[0].label,
        });
        setCultureError(false);
      }
    } catch (error) {
    }
  };

  useEffect(() => {
    getAgronomists();
    getCultures();
    getAllProducers();
  }, []);

  useEffect(() => {
    if (producerDrawer?.value) {
      getAgroFarms(producerDrawer.value);
    }
  }, [producerDrawer?.value]);

  const [responsavelTecnicoSelecionado, setResponsavelTecnicoSelecionado] = useState(null);
  const [produtorSelecionado, setProdutorSelecionado] = useState(null);
  const [fazendaSelecionada, setFazendaSelecionada] = useState(null);
  const [culturaSelecionada, setCulturaSelecionada] = useState(null);

  return (
    <S.Container>
      <S.Wrapper>
        <S.CalendaryEvent>
          <S.ScheduleAndNewEvent>
            <BodyG color={theme.colors.gray.Cinza_2} fontWeight={700}>
              Meu calendário
            </BodyG>

            <S.NewEvent onClick={handleCreateEventClick}>
              <img src={IconPlusBlue} alt="Ícone de mais em azul" style={{ width: "16px", height: "16px" }}/>

              <TaglineM color={theme.colors.blue.Azul_link} fontWeight={800}>CRIAR EVENTO</TaglineM>
            </S.NewEvent>
          </S.ScheduleAndNewEvent>

          <Calendar
            onChange={setCurrentDate}
            value={currentDate}
            prevLabel={<img src={IconArrowLeft} alt="Seta para a esquerda" />}
            nextLabel={<img src={IconArrowRight} alt="Seta para a direita" />}
            prev2Label={null}
            next2Label={null}
            tileClassName={tileClassName}
            calendarType="gregory"
            navigationLabel={({ date }) =>
              date
                .toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' })
                .replace(' de ', ' ')
            }
            formatShortWeekday={(locale, date) =>
              date
                .toLocaleDateString('pt-BR', { weekday: 'short' })
                .charAt(0)
                .toUpperCase()
            }
          />
        </S.CalendaryEvent>
      </S.Wrapper>

      <ModalCreateOrEditEvent
        open={showNewEvent}
        onOpenChange={(e) => {
          setShowNewEvent(e);
          if (!e) {
            clearFields();
            setIsEdit(false);
          }
        }}
        isEdit={isEdit}
        styles={S}
        responsavelTecnicoValue={responsavelTecnicoSelecionado ? responsavelTecnicoSelecionado.value : ""}
        onResponsavelTecnicoChange={(selectedOption) => {
          setResponsavelTecnicoSelecionado(selectedOption);
          setAgronomistError(false);
        }}
        agronomists={agronomists}
        agronomistError={agronomistError}
        onAddAgronomist={() => setShowAddAgronomist(true)}
        produtorValue={produtorSelecionado ? produtorSelecionado.value : ""}
        onProdutorChange={(selectedOption) => {
          setProdutorSelecionado(selectedOption);
          getAgroFarms(selectedOption.value);
          setIdProducer(selectedOption.value);
          if (!selectedOption.value) {
            setFazendaSelecionada(null);
          }
          setProducerError(false);
        }}
        producers={producers}
        producerError={producerError}
        onAddProducer={() => setShowAddProducer(true)}
        fazendaValue={fazendaSelecionada ? fazendaSelecionada.value : ""}
        onFazendaChange={(selectedOption) => {
          setFazendaSelecionada(selectedOption);
          setFarmError(false);
        }}
        agroFarms={agroFarms}
        farmError={farmError}
        isFarmDisabled={isFarmDisabled}
        isButtonFarmDisabled={isButtonFarmDisabled}
        onAddFarm={() => setShowAddFarm(true)}
        titleValue={titleDrawer}
        onTitleChange={(e) => {
          setTitleDrawer(e.target.value);
          if (e.target.value.trim()) setTitleError(false);
        }}
        titleError={titleError}
        descriptionValue={descriptionDrawer}
        onDescriptionChange={(e) => {
          setDescriptionDrawer(e.target.value);
          if (e.target.value.trim()) setDescriptionError(false);
        }}
        descriptionError={descriptionError}
        culturaValue={culturaSelecionada ? culturaSelecionada.value : ""}
        onCulturaChange={(selectedOption) => {
          setCulturaSelecionada({
            value: selectedOption.value,
            label: selectedOption.label,
          });
          setCultureError(false);
        }}
        cultures={cultures}
        cultureError={cultureError}
        startDateValue={startDateDrawer}
        onStartDateChange={(e) => {
          setStartDateDrawer(e.target.value);
          if (e.target.value) setStartDateError(false);
        }}
        startDateError={startDateError}
        endDateValue={endDateDrawer}
        onEndDateChange={(e) => {
          setEndDateDrawer(e.target.value);
          if (e.target.value) setEndDateError(false);
        }}
        endDateError={endDateError}
        statusRef={selectStatusRef}
        statusValue={statusDrawer.value ? statusDrawer : null}
        onStatusChange={(selectedOption) => {
          setStatusDrawer({
            value: selectedOption.value,
            label: selectedOption.label,
          });
          setStatusError(false);
        }}
        statusError={statusError}
        commentResourceId={0}
        onSave={isEdit ? handleEditEvent : handleSaveEvent}
        isLoading={isLoading}
      />

      {showAddAgronomist && (
        <Modal show={showAddAgronomist} title="Cadastrar novo responsável técnico" onHide={() => setShowAddAgronomist(false)}>
          <RegisterAgronomist
            onSuccess={() => {
              getAgronomists();
              setShowAddAgronomist(false);
            }}
            onCancel={() => setShowAddAgronomist(false)}
          />
        </Modal>
      )}

      {showAddProducer && (
        <Modal show={showAddProducer} title="Cadastrar novo produtor" onHide={() => setShowAddProducer(false)}>
          <RegisterProducer
            onSuccess={() => {
              setShowAddProducer(false);
            }}
            onCancel={() => setShowAddProducer(false)}
          />
        </Modal>
      )}

      {showAddFarm && (
        <Modal show={showAddFarm} title="Cadastrar nova fazenda" onHide={() => setShowAddFarm(false)}>
          <RegisterFarm
            producerId={idProducer}
            onSuccess={() => {
              getAgroFarms(idProducer);
              setShowAddFarm(false);
            }}
            onCancel={() => setShowAddFarm(false)}
          />
        </Modal>
      )}

      {openModalTrue ? (
        <ModalBlock show={openModalTrue} onHide={() => setOpenModalTrue(false)} />
      ) : null}
    </S.Container>
  );
};

export default CalendaryEvent;
